import { useState } from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

const pricingPlans = [
  {
    id: 1,
    name: "Starter",
    subtitle: "Perfect for small businesses",
    price: {
      monthly: 899,
      annually: 8990
    },
    color: "from-blue-500 to-indigo-600",
    popular: false,
    description: "Get started with essential digital marketing services to grow your online presence.",
    features: [
      { name: "Social Media Management", included: true },
      { name: "Basic SEO Optimization", included: true },
      { name: "Monthly Performance Reports", included: true },
      { name: "Email Marketing (up to 5k contacts)", included: true },
      { name: "Content Creation (4 posts/month)", included: true },
      { name: "Google Business Profile Setup", included: true },
      { name: "META Ads Management", included: false },
      { name: "Google Paid Ads", included: false },
      { name: "Advanced Analytics", included: false },
      { name: "Dedicated Account Manager", included: false }
    ],
    support: "Email Support",
    setupFee: "Free",
    contract: "Monthly"
  },
  {
    id: 2,
    name: "Professional",
    subtitle: "Most popular for growing businesses",
    price: {
      monthly: 1999,
      annually: 19990
    },
    color: "from-indigo-600 to-purple-600",
    popular: true,
    description: "Comprehensive marketing solution with paid advertising and advanced features.",
    features: [
      { name: "Social Media Management", included: true },
      { name: "Advanced SEO Optimization", included: true },
      { name: "Weekly Performance Reports", included: true },
      { name: "Email Marketing (up to 25k contacts)", included: true },
      { name: "Content Creation (12 posts/month)", included: true },
      { name: "Google Business Profile Management", included: true },
      { name: "META Ads Management (up to $3k spend)", included: true },
      { name: "Google Paid Ads (up to $3k spend)", included: true },
      { name: "Advanced Analytics Dashboard", included: true },
      { name: "Dedicated Account Manager", included: false }
    ],
    support: "Priority Email & Chat Support",
    setupFee: "Free",
    contract: "3 Months Minimum"
  },
  {
    id: 3,
    name: "Enterprise",
    subtitle: "For established businesses",
    price: {
      monthly: 4999,
      annually: 49990
    },
    color: "from-purple-600 to-pink-600",
    popular: false,
    description: "Full-service digital marketing with unlimited campaigns and dedicated support.",
    features: [
      { name: "Social Media Management (All Platforms)", included: true },
      { name: "Enterprise SEO Strategy", included: true },
      { name: "Real-time Performance Dashboard", included: true },
      { name: "Email Marketing (Unlimited contacts)", included: true },
      { name: "Content Creation (Unlimited)", included: true },
      { name: "Multi-location Management", included: true },
      { name: "META Ads Management (Unlimited spend)", included: true },
      { name: "Google Paid Ads (Unlimited spend)", included: true },
      { name: "AI-Powered Analytics & Insights", included: true },
      { name: "Dedicated Account Manager", included: true }
    ],
    support: "24/7 Phone, Email & Chat Support",
    setupFee: "Free",
    contract: "6 Months Minimum"
  }
];

const addOns = [
  {
    id: 1,
    name: "Video Production",
    description: "Professional video content for social media and ads",
    price: 499,
    icon: (
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z" />
    )
  },
  {
    id: 2,
    name: "Influencer Marketing",
    description: "Connect with relevant influencers in your niche",
    price: 799,
    icon: (
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
    )
  },
  {
    id: 3,
    name: "Website Development",
    description: "Custom website design and development",
    price: 2999,
    icon: (
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
    )
  },
  {
    id: 4,
    name: "Conversion Rate Optimization",
    description: "A/B testing and landing page optimization",
    price: 899,
    icon: (
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
    )
  },
  {
    id: 5,
    name: "Reputation Management",
    description: "Monitor and manage online reviews",
    price: 399,
    icon: (
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M11.049 2.927c.3-.921 1.603-.921 1.902 0l1.519 4.674a1 1 0 00.95.69h4.915c.969 0 1.371 1.24.588 1.81l-3.976 2.888a1 1 0 00-.363 1.118l1.518 4.674c.3.922-.755 1.688-1.538 1.118l-3.976-2.888a1 1 0 00-1.176 0l-3.976 2.888c-.783.57-1.838-.197-1.538-1.118l1.518-4.674a1 1 0 00-.363-1.118l-3.976-2.888c-.784-.57-.38-1.81.588-1.81h4.914a1 1 0 00.951-.69l1.519-4.674z" />
    )
  },
  {
    id: 6,
    name: "Marketing Automation",
    description: "Advanced automation workflows and CRM integration",
    price: 699,
    icon: (
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
    )
  }
];

const faqs = [
  {
    question: "Can I change my plan later?",
    answer: "Yes! You can upgrade or downgrade your plan at any time. When upgrading, you'll get immediate access to new features. When downgrading, changes take effect at the start of your next billing cycle."
  },
  {
    question: "What happens if I exceed my ad spend limit?",
    answer: "We'll notify you when you're approaching your limit. You can either upgrade to a higher tier or pay a small management fee (10% of additional spend) to continue your campaigns without interruption."
  },
  {
    question: "Do you offer custom packages?",
    answer: "Absolutely! If none of our standard plans fit your needs, we can create a custom package tailored to your specific requirements and budget. Contact us for a personalized quote."
  },
  {
    question: "Is there a setup fee?",
    answer: "No setup fees for any of our plans! We believe in transparent pricing, so what you see is what you pay."
  },
  {
    question: "What's your cancellation policy?",
    answer: "You can cancel anytime with 30 days notice. For plans with minimum contracts, early cancellation fees may apply. We'll work with you to ensure a smooth transition."
  },
  {
    question: "Do you provide reports?",
    answer: "Yes! All plans include detailed performance reports. Starter gets monthly reports, Professional gets weekly reports, and Enterprise gets real-time dashboard access plus custom reports on demand."
  }
];

const PricingPage = () => {
  const [billingCycle, setBillingCycle] = useState("monthly");
  const [selectedAddOns, setSelectedAddOns] = useState([]);
  const [openFaq, setOpenFaq] = useState(null);

  const toggleAddOn = (addOnId) => {
    setSelectedAddOns(prev =>
      prev.includes(addOnId)
        ? prev.filter(id => id !== addOnId)
        : [...prev, addOnId]
    );
  };

  const calculateSavings = (monthly, annually) => {
    const monthlyCost = monthly * 12;
    const savings = monthlyCost - annually;
    const percentage = Math.round((savings / monthlyCost) * 100);
    return { savings, percentage };
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-indigo-50">
      <Navbar />
      
      {/* Hero Section */}
      <div className="pt-32 pb-20 px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto text-center">
          <div className="inline-flex items-center px-4 py-2 rounded-full bg-indigo-100 border border-indigo-200 mb-6">
            <span className="w-2 h-2 bg-indigo-600 rounded-full mr-2 animate-pulse"></span>
            <span className="text-sm font-medium text-indigo-700 uppercase tracking-wider">
              Transparent Pricing
            </span>
          </div>
          
          <h1 className="text-5xl md:text-6xl font-bold bg-gradient-to-r from-gray-900 to-indigo-900 bg-clip-text text-transparent mb-6">
            Simple, Transparent Pricing
          </h1>
          <h2 className="text-3xl md:text-4xl font-bold bg-gradient-to-r from-indigo-600 to-purple-600 bg-clip-text text-transparent mb-8">
            No Hidden Fees, Ever
          </h2>
          
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed mb-12">
            Choose the perfect plan for your business. All plans include our core services with no setup fees or long-term contracts.
          </p>

          {/* Billing Toggle */}
          <div className="inline-flex items-center bg-white rounded-2xl p-2 shadow-lg">
            <button
              onClick={() => setBillingCycle("monthly")}
              className={`px-8 py-3 rounded-xl font-semibold transition-all duration-300 ${
                billingCycle === "monthly"
                  ? "bg-gradient-to-r from-indigo-600 to-purple-600 text-white shadow-lg"
                  : "text-gray-600 hover:text-gray-900"
              }`}
            >
              Monthly
            </button>
            <button
              onClick={() => setBillingCycle("annually")}
              className={`px-8 py-3 rounded-xl font-semibold transition-all duration-300 relative ${
                billingCycle === "annually"
                  ? "bg-gradient-to-r from-indigo-600 to-purple-600 text-white shadow-lg"
                  : "text-gray-600 hover:text-gray-900"
              }`}
            >
              Annually
              <span className="absolute -top-2 -right-2 bg-green-500 text-white text-xs px-2 py-1 rounded-full">
                Save 10%
              </span>
            </button>
          </div>
        </div>
      </div>

      {/* Pricing Cards */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-20">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {pricingPlans.map((plan) => {
            const { savings, percentage } = calculateSavings(plan.price.monthly, plan.price.annually);
            const displayPrice = billingCycle === "monthly" ? plan.price.monthly : Math.round(plan.price.annually / 12);

            return (
              <div
                key={plan.id}
                className={`relative bg-white rounded-3xl p-8 border-2 transition-all duration-500 hover:scale-105 ${
                  plan.popular
                    ? "border-indigo-600 shadow-2xl shadow-indigo-500/20"
                    : "border-gray-200 shadow-lg hover:shadow-xl"
                }`}
              >
                {plan.popular && (
                  <div className="absolute -top-4 left-1/2 transform -translate-x-1/2">
                    <span className="bg-gradient-to-r from-indigo-600 to-purple-600 text-white px-6 py-2 rounded-full text-sm font-bold shadow-lg">
                      Most Popular
                    </span>
                  </div>
                )}

                <div className="text-center mb-8">
                  <h3 className="text-2xl font-bold text-gray-900 mb-2">{plan.name}</h3>
                  <p className="text-sm text-gray-600 mb-6">{plan.subtitle}</p>
                  
                  <div className="mb-4">
                    <span className="text-5xl font-bold text-gray-900">${displayPrice}</span>
                    <span className="text-gray-600">/month</span>
                  </div>

                  {billingCycle === "annually" && (
                    <div className="text-sm text-green-600 font-semibold">
                      Save ${savings}/year ({percentage}% off)
                    </div>
                  )}

                  <p className="text-sm text-gray-500 mt-4">{plan.description}</p>
                </div>

                <button className={`w-full py-4 rounded-xl font-semibold transition-all duration-300 transform hover:scale-105 mb-8 ${
                  plan.popular
                    ? `bg-gradient-to-r ${plan.color} text-white shadow-lg hover:shadow-xl`
                    : "bg-gray-100 text-gray-900 hover:bg-gray-200"
                }`}>
                  Get Started
                </button>

                <div className="space-y-4 mb-8">
                  {plan.features.map((feature, idx) => (
                    <div key={idx} className="flex items-start">
                      {feature.included ? (
                        <svg className="h-6 w-6 text-green-500 mr-3 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                        </svg>
                      ) : (
                        <svg className="h-6 w-6 text-gray-300 mr-3 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                        </svg>
                      )}
                      <span className={feature.included ? "text-gray-700" : "text-gray-400"}>
                        {feature.name}
                      </span>
                    </div>
                  ))}
                </div>

                <div className="pt-6 border-t border-gray-200 space-y-3 text-sm">
                  <div className="flex justify-between">
                    <span className="text-gray-600">Support:</span>
                    <span className="font-semibold text-gray-900">{plan.support}</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-gray-600">Setup Fee:</span>
                    <span className="font-semibold text-green-600">{plan.setupFee}</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-gray-600">Contract:</span>
                    <span className="font-semibold text-gray-900">{plan.contract}</span>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>

      {/* Add-Ons Section */}
      <div className="bg-white py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">Enhance Your Plan</h2>
            <p className="text-xl text-gray-600">Add extra services to supercharge your marketing</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {addOns.map((addOn) => (
              <div
                key={addOn.id}
                onClick={() => toggleAddOn(addOn.id)}
                className={`relative bg-white rounded-2xl p-6 border-2 cursor-pointer transition-all duration-300 hover:shadow-lg ${
                  selectedAddOns.includes(addOn.id)
                    ? "border-indigo-600 shadow-lg"
                    : "border-gray-200"
                }`}
              >
                {selectedAddOns.includes(addOn.id) && (
                  <div className="absolute top-4 right-4">
                    <div className="bg-indigo-600 text-white rounded-full p-1">
                      <svg className="h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                      </svg>
                    </div>
                  </div>
                )}

                <div className="bg-indigo-100 rounded-xl p-3 inline-block mb-4">
                  <svg className="h-8 w-8 text-indigo-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    {addOn.icon}
                  </svg>
                </div>

                <h3 className="text-xl font-bold text-gray-900 mb-2">{addOn.name}</h3>
                <p className="text-gray-600 mb-4">{addOn.description}</p>
                <p className="text-2xl font-bold text-indigo-600">${addOn.price}/month</p>
              </div>
            ))}
          </div>

          {selectedAddOns.length > 0 && (
            <div className="mt-12 bg-gradient-to-r from-indigo-50 to-purple-50 rounded-2xl p-8 text-center">
              <h3 className="text-2xl font-bold text-gray-900 mb-4">Selected Add-Ons</h3>
              <p className="text-xl text-gray-600 mb-6">
                Total Additional Cost: <span className="font-bold text-indigo-600">
                  ${addOns.filter(a => selectedAddOns.includes(a.id)).reduce((sum, a) => sum + a.price, 0)}/month
                </span>
              </p>
              <button className="bg-gradient-to-r from-indigo-600 to-purple-600 text-white px-8 py-4 rounded-xl font-semibold hover:shadow-lg transition-all duration-300 transform hover:scale-105">
                Add to Plan
              </button>
            </div>
          )}
        </div>
      </div>

      {/* FAQ Section */}
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">Frequently Asked Questions</h2>
          <p className="text-xl text-gray-600">Everything you need to know about our pricing</p>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl border border-gray-200 overflow-hidden transition-all duration-300 hover:shadow-lg"
            >
              <button
                onClick={() => setOpenFaq(openFaq === index ? null : index)}
                className="w-full px-6 py-5 text-left flex justify-between items-center"
              >
                <span className="text-lg font-semibold text-gray-900">{faq.question}</span>
                <svg
                  className={`h-6 w-6 text-indigo-600 transition-transform duration-300 ${
                    openFaq === index ? "transform rotate-180" : ""
                  }`}
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                </svg>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openFaq === index ? "max-h-96" : "max-h-0"
                }`}
              >
                <div className="px-6 pb-5 text-gray-600 leading-relaxed">
                  {faq.answer}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* CTA Section */}
      <div className="bg-gradient-to-r from-indigo-600 to-purple-600 py-20">
        <div className="max-w-4xl mx-auto text-center px-4">
          <h2 className="text-4xl font-bold text-white mb-6">
            Still Have Questions?
          </h2>
          <p className="text-xl text-indigo-100 mb-8">
            Our team is here to help you choose the perfect plan for your business.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button className="bg-white text-indigo-600 px-8 py-4 rounded-xl font-semibold hover:shadow-2xl transition-all duration-300 transform hover:scale-105">
              Schedule a Call
            </button>
            <button className="border-2 border-white text-white px-8 py-4 rounded-xl font-semibold hover:bg-white hover:text-indigo-600 transition-all duration-300 transform hover:scale-105">
              Chat with Sales
            </button>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default PricingPage;
